module.exports = __webpack_public_path__ + "img/apple_contrast.a1f05f5d.png";